import { formURL } from "./store";
import { get } from 'svelte/store';
import { PUBLIC_DOMAIN } from '$env/static/public';
export class REST {
    static _formURL: string;
    static init() {
        REST._formURL = get(formURL)
        formURL.subscribe((url) => {
            REST._formURL = url
        })
    }

    static async GET(resource: string, params: { [key: string]: string }): Promise<Response> {
        const queryParams = new URLSearchParams({ ...params, ...{ formURL: REST._formURL } }).toString()
        const url = `${PUBLIC_DOMAIN}/api/${resource}?${queryParams}`
        return fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }

    static async POST(resource: string, body: object, params?: { [key: string]: string }): Promise<Response> {
        const safeParams = params || {};
        const queryParams = new URLSearchParams({ ...safeParams, ...{ formURL: REST._formURL } }).toString()
        const url = `${PUBLIC_DOMAIN}/api/${resource}?${queryParams}`
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
    }

    static async PUT(resource: string, body: object, params?: { [key: string]: string }): Promise<Response> {
        const safeParams = params || {};
        const queryParams = new URLSearchParams({ ...safeParams, ...{ formURL: REST._formURL } }).toString()
        const url = `${PUBLIC_DOMAIN}/api/${resource}?${queryParams}`
        return fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
    }

    static async DELETE(resource: string, params?: { [key: string]: string }): Promise<Response> {
        const safeParams = params || {};
        const queryParams = new URLSearchParams({ ...safeParams, ...{ formURL: REST._formURL } }).toString()
        const url = `${PUBLIC_DOMAIN}/api/${resource}?${queryParams}`
        return fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }
}

REST.init()